import React from 'react';
 
const Health = () => {
  const currentTime = new Date().toLocaleString();
  const apiUrl = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5199/api';;
 
  return (
    <div style={{
      fontFamily: 'Arial, sans-serif',
      padding: '20px',
      maxWidth: '600px',
      margin: '0 auto',
      backgroundColor: '#f8f9fa',
      borderRadius: '8px',
      boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
    }}>
      <h1 style={{
        color: '#28a745',
        textAlign: 'center',
        marginBottom: '30px'
      }}>
        ✅ Application Health Check
      </h1>
      
      <div style={{
        backgroundColor: 'white',
        padding: '20px',
        borderRadius: '5px',
        marginBottom: '20px'
      }}>
        <h2 style={{ color: '#495057', marginBottom: '15px' }}>Status</h2>
        <p style={{ fontSize: '18px', color: '#28a745', fontWeight: 'bold' }}>
          🟢 Application is UP and RUNNING
        </p>
      </div>
 
      <div style={{
        backgroundColor: 'white',
        padding: '20px',
        borderRadius: '5px',
        marginBottom: '20px'
      }}>
        <h2 style={{ color: '#495057', marginBottom: '15px' }}>Application Details</h2>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr>
                <th style={{ padding: '8px 0', fontWeight: 'bold', color: '#343a40', backgroundColor: '#f1f3f5', textAlign: 'left' }}>Property</th>
                <th style={{ padding: '8px 0', fontWeight: 'bold', color: '#343a40', backgroundColor: '#f1f3f5', textAlign: 'left' }}>Value</th>
              </tr>
            </thead>
            <tbody>
              <tr style={{ borderBottom: '1px solid #dee2e6' }}>
                <td style={{ padding: '8px 0', fontWeight: 'bold', color: '#6c757d' }}>Application Name:</td>
                <td style={{ padding: '8px 0' }}>CCA CustomCards Frontend</td>
              </tr>
              <tr style={{ borderBottom: '1px solid #dee2e6' }}>
                <td style={{ padding: '8px 0', fontWeight: 'bold', color: '#6c757d' }}>API URL:</td>
                <td style={{ padding: '8px 0' }}>{apiUrl}</td>
              </tr>
              <tr style={{ borderBottom: '1px solid #dee2e6' }}>
                <td style={{ padding: '8px 0', fontWeight: 'bold', color: '#6c757d' }}>Environment:</td>
                <td style={{ padding: '8px 0' }}>{process.env.REACT_APP_NODE_ENV || 'development'}</td>
              </tr>
              <tr>
                <td style={{ padding: '8px 0', fontWeight: 'bold', color: '#6c757d' }}>Current Time:</td>
                <td style={{ padding: '8px 0' }}>{currentTime}</td>
            </tr>
          </tbody>
        </table>
      </div>
 
      <div style={{
        textAlign: 'center',
        marginTop: '20px',
        padding: '10px',
        backgroundColor: '#e9ecef',
        borderRadius: '5px'
      }}>
        <small style={{ color: '#6c757d' }}>
          Health check endpoint: /ui/health
        </small>
      </div>
    </div>
  );
};
 
export default Health;
